import { useState } from "react";
import Categories from "./_Categories";

export default function Accordion({company, cvmCode}) {
    const [open, setOpen] = useState(false);
    
    return (
        <li className="pageCVM__singleCompany">
            <div
                className={"pageCVM__singleCompany__header accordion__header"  + (open ? ' active' : '')}
                onClick={() => setOpen(!open)}>
                <div className="pageCVM__singleCompany__names">
                    <span className="pageCVM__singleCompany__tradeName">{company.nome}</span>
                </div>

                <div className="pageCVM__singleCompany__icon"></div>
            </div>

            <div className="pageCVM__singleCompany__content accordion__content">
                <ul className="pageCVM__categories">
                    <Categories
                        categories={company.categories}
                        cvmCode={cvmCode} />
                </ul>
            </div>
        </li>
    );
}